import React, { useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useParams } from 'react-router-dom'
import SearchInput from 'src/components/SearchInput/SearchInput'
import DateCell from 'src/components/Table/CellComponents/DateCell'
import FormattedCell from 'src/components/Table/CellComponents/FormattedCell'
import Table from 'src/components/Table/Table'
import { useUserActivity, useClient } from 'src/hooks/api'
import { useExportUserData } from 'src/util/exportXlsx'
import { filterUserActivities } from 'src/util/filters'

const ActivityUser = () => {
  const { id } = useParams()
  const client = useClient()
  const activity = useUserActivity(id)
  const [filter, setFilter] = useState('')
  const filteredActivity = useMemo(() => (activity || []).filter(filterUserActivities(filter)), [activity, filter])
  const exportXlsx = useExportUserData(id, `userActivity_${client.fullname.replace(/\s/g, '')}`)

  return (
    <div id="activity-user">
      <div className="utilities">
        <SearchInput value={filter} onChange={setFilter} />
        <button onClick={exportXlsx} className="export">
          <FormattedMessage id="user.export" />
          <span className="icon icon-excel" />
        </button>
      </div>

      <Table
        name={'activity'}
        data={filteredActivity}
        columns={[
          { name: 'subscriberCode' },
          { name: 'action', component: FormattedCell },
          { name: 'address' },
          { name: 'dateAction', component: DateCell }
        ]}
      />
    </div>
  )
}

export default ActivityUser
